import { CityTypeT } from '../types/cities.types'

export const CitiesTypes: CityTypeT[] = [
    { id: 1, name: 'Областной центр' },
    { id: 2, name: 'Международка' },
    { id: 3, name: 'Посёлок' },
    { id: 4, name: 'Город республиканского значения' }
]
